'use client'

import ListingsStandard from '@component/card/listings/standard'
import SectionLayout from '@component/layout/section'
import SectionSwiper from '@component/layout/section/swiper'

export default function Content ({
  data
}) {
  return (
    <SectionLayout title='Properties for sale'>
      <SectionSwiper data={data} Card={ListingsStandard}></SectionSwiper>
    </SectionLayout>
  )
}